"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M11.9999 15.0002c-1.3965 0-2.5725-.9551-2.9056-2.2492l-1.9368.4985c.555 2.1563 2.5112 3.7507 4.8424 3.7507 2.3312 0 4.2874-1.5944 4.8424-3.7507l-1.9369-.4985c-.3331 1.2941-1.509 2.2492-2.9055 2.2492zM11 9.5c0 .8284-.6716 1.5-1.5 1.5S8 10.3284 8 9.5 8.6716 8 9.5 8s1.5.6716 1.5 1.5zm3.5 1.5c.8284 0 1.5-.6716 1.5-1.5S15.3284 8 14.5 8 13 8.6716 13 9.5s.6716 1.5 1.5 1.5z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12c0 4.9706-4.0294 9-9 9s-9-4.0294-9-9 4.0294-9 9-9 9 4.0294 9 9zm-2 0c0 3.866-3.134 7-7 7s-7-3.134-7-7 3.134-7 7-7 7 3.134 7 7z"
  })];
};

exports.default = _default;